module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "address-form"
  }, [_c('div', {
    staticClass: "panel__block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.setFormTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "panel__block"
  }, [_c('div', {
    staticClass: "address-wrap"
  }, [_c('div', {
    staticClass: "address-form__cell"
  }, [_c('TextInput', {
    attrs: {
      "context": "address",
      "type": "text",
      "value": _vm.setFieldValue('line1'),
      "label": "Line 1",
      "id": "line1",
      "field": _vm.setField('line1')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-form__cell"
  }, [_c('TextInput', {
    attrs: {
      "context": "address",
      "type": "text",
      "value": _vm.setFieldValue('line2'),
      "label": "Line 2",
      "id": "line2",
      "field": _vm.setField('line2')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-form__cell"
  }, [_c('TextInput', {
    attrs: {
      "context": "address",
      "type": "text",
      "value": _vm.setFieldValue('line3'),
      "label": "Line 3",
      "id": "line3",
      "field": _vm.setField('line3')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "address-form__cell cell-50"
  }, [_c('TextInput', {
    attrs: {
      "context": "address",
      "type": "text",
      "value": _vm.setFieldValue('city'),
      "label": "City",
      "id": "city",
      "field": _vm.setField('city')
    }
  })], 1), _c('div', {
    staticClass: "address-form__cell cell-25"
  }, [_c('Dropdown', {
    attrs: {
      "id": "province",
      "label": "Province",
      "proto": "province",
      "field": _vm.setField('province')
    }
  })], 1), _c('div', {
    staticClass: "address-form__cell cell-25"
  }, [_c('TextInput', {
    attrs: {
      "context": "address",
      "type": "text",
      "value": _vm.setFieldValue('postalcode'),
      "label": "Postal Code",
      "id": "postalcode",
      "field": _vm.setField('postalcode')
    }
  })], 1), _c('div', {
    staticClass: "address-form__cell cell-50"
  }, [_c('Dropdown', {
    attrs: {
      "id": "country",
      "label": "Country",
      "proto": "country",
      "field": _vm.setField('country')
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86ba0768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressForm.vue
// module id = 331
// module chunks = 0